import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

import pages from 'pages';
import useUser from 'hooks/useUser';
import { useFeatureFlags } from 'hooks/useFeatureFlags';
import { FlagKey } from 'api/types';
import { Header } from 'shared/components/Header/Header';
import { Text } from 'shared/components/Text/Text';
import { Button } from 'shared/components/Button/Button';
import { VPPEnrollmentGraphic } from 'modules/vpp/components/VPPEnrollmentGraphic/VPPEnrollmentGraphic';
import { BodyTextWrapper, Title, VPPBody, VPPTextWrapper, VPPWrapper } from './VPP.styles';

export function VPP() {
  const { t } = useTranslation();
  const { selectedAgreement } = useUser();
  const navigate = useNavigate();

  const {
    loading,
    flags: { [FlagKey.vpp2025_prelaunch_web]: vpp },
  } = useFeatureFlags();

  if (loading) {
    return null;
  }
  const isVppEnabled = vpp && selectedAgreement?.system.is_vpp_enrolled;
  if (!isVppEnabled) {
    return <Navigate to={`/${pages.DASHBOARD}`} replace />;
  }

  return (
    <VPPWrapper>
      <Header pageName="VPP" title={t('vpp.virtualPowerPlant')} />

      <VPPBody>
        <VPPEnrollmentGraphic />

        <VPPTextWrapper>
          <Title as="h1">{t('vpp.enrollInVPP')}</Title>
          <BodyTextWrapper>
            <Text as="p">
              <Trans
                i18nKey="vpp.asPartOfYourAgreement"
                components={{
                  strong: <b />,
                }}
              />
            </Text>
            <Text as="p">{t('vpp.youllEarnRewards')}</Text>
          </BodyTextWrapper>

          <Button
            label={t('vpp.learnMore')}
            onClick={() => {
              navigate(pages.VPP_FAQS);
            }}
          />
        </VPPTextWrapper>
      </VPPBody>
    </VPPWrapper>
  );
}
export default VPP;
